import { MainMachineContext } from '../state';

export function useMainMachine() {
  const { useSelector, useActorRef } = MainMachineContext;
  const machine = useActorRef();

  return { useSelector, machine };
}
